/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalIntegration } from './PalIntegration';
import {
    PalIntegrationFromJSON,
    PalIntegrationFromJSONTyped,
    PalIntegrationToJSON,
} from './PalIntegration';

/**
 * 
 * @export
 * @interface FindAllPalIntegrationsByFacilityId200Response
 */
export interface FindAllPalIntegrationsByFacilityId200Response {
    /**
     * 
     * @type {Array<PalIntegration>}
     * @memberof FindAllPalIntegrationsByFacilityId200Response
     */
    data?: Array<PalIntegration>;
}

/**
 * Check if a given object implements the FindAllPalIntegrationsByFacilityId200Response interface.
 */
export function instanceOfFindAllPalIntegrationsByFacilityId200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPalIntegrationsByFacilityId200ResponseFromJSON(json: any): FindAllPalIntegrationsByFacilityId200Response {
    return FindAllPalIntegrationsByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindAllPalIntegrationsByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalIntegrationsByFacilityId200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PalIntegrationFromJSON)),
    };
}

export function FindAllPalIntegrationsByFacilityId200ResponseToJSON(value?: FindAllPalIntegrationsByFacilityId200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PalIntegrationToJSON)),
    };
}

